function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "gentle-wave",
  d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "parallax"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gentle-wave",
  x: 48,
  y: 0,
  fill: "var(--wave1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gentle-wave",
  x: 48,
  y: 3,
  fill: "var(--wave2)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gentle-wave",
  x: 48,
  y: 5,
  fill: "var(--wave3)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gentle-wave",
  x: 48,
  y: 7,
  fill: "var(--wave4)"
}));

var SvgWaves = function SvgWaves(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "waves",
    viewBox: "0 24 150 28",
    preserveAspectRatio: "none",
    shapeRendering: "auto",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaves, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Waves.9d64687e.svg";
export { ForwardRef as ReactComponent };